import { websiteLabel } from '@/utils/websiteLabel'

/**
 * A workspace's own website (ORB-1027). Blank means it has none and uses the company's; the knowledge base agent reads
 * the workspace's own site for it, and its landing pages link there.
 */

/** The company a workspace falls back on: its name and its own website, which a workspace without one uses. */
export interface CompanyWebsite {
  companyName: string
  companyWebsite: string | null
}

/**
 * Whether the API will take a website, as `WorkspaceValidator.ValidateWebsite` decides it: blank is no website, and
 * anything else is an absolute http or https address whose host has a dot. Checked on the trimmed value, as the API
 * checks and stores it.
 */
export function isWorkspaceWebsite(value: string): boolean {
  const trimmed = value.trim()
  if (trimmed === '') return true
  try {
    const url = new URL(trimmed)
    return (url.protocol === 'http:' || url.protocol === 'https:') && url.hostname.includes('.')
  } catch {
    return false
  }
}

/** What the Website field says under it: what the site is used for, and what a blank one means. */
export function websiteHelp({ companyName, companyWebsite }: CompanyWebsite): string {
  const host = websiteLabel(companyWebsite)
  return 'The knowledge base agent reads this site for this workspace, and its landing pages link here. '
    + `Leave blank to use ${companyName}'s website${host ? `, ${host}` : ''}.`
}
